import React, { useState } from "react";
//import "./document.css";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const Document = ({moduleContent, updateLmsModule, course}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [completed, setCompleted] = useState(false);
  const [loader, setLoader] = useState(false);
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const currentLang = course?.lang;

   const getLangCode = (lang) => {
    switch (lang) {
      case 'English':
        return 'en'; 
      case 'Hindi':
        return 'hi';
      case 'Marathi':
        return 'mar';
      default:
        return 'en';
    }
  };

  const langId = getLangCode(currentLang);
  const tForLang = i18n.getFixedT(langId);

   const handleMarkAsCompleted = async (data) => {

    updateLmsModule().then((data) => {

    });

    setCompleted(true);
  };

  return (
    <>
      <div className="document-page">
        <div className="text-center my-4"><div dangerouslySetInnerHTML={{ __html: moduleContent?.content }} /></div>
        <div className="pdf-container">
          {moduleContent?.document ? (() => {
            const url = moduleContent.document;
            const ext = url.split('.').pop().toLowerCase();

            let embedUrl = '';

            if (ext === 'pdf') {
              embedUrl = moduleContent.downloadable ? url : `${url}#toolbar=0`;
            } else if (['doc', 'docx', 'xls', 'xlsx'].includes(ext)) {
              embedUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`;
            } else {
              return <p>Unsupported file format.</p>;
            }

            return (
              <iframe
                src={embedUrl}
                className="pdf-iframe"
                title="PDF Viewer"
                frameBorder="0"
                width="100%"
                height="600px"
                toolbar="0"
              />
            );
          })() : (
            <p>No document available.</p>
          )}

        </div>
      </div>
      <div className='text-end mt-4 pt-4 border-top'>
        {moduleContent.downloadable && (
          <a className="btn btn-md btn-primary me-2" download target="_blank" href={moduleContent?.document}>
            {tForLang('course_modules_doc_download')}
          </a>
        )}
        {!moduleContent?.module_status && (
          <button onClick={handleMarkAsCompleted} className='btn btn-md btn-primary '>{tForLang('course_modules_next')}</button>
        )}
        {moduleContent?.module_status && (
          <button onClick={handleMarkAsCompleted} className='btn btn-md btn-primary '>{tForLang('course_modules_next')}</button>
        )}
      </div>
      </>
  );
};

export default Document;